import { useSelector } from 'react-redux';
import { ITabLayout } from '../../types/layout/tabs';
import { commentariesListSelector } from '../../redux/selectors/commentaries';

function TabTitle({ commentariesCount, title }: ITabLayout) {
    const list = useSelector(commentariesListSelector(commentariesCount));

    if (typeof commentariesCount === 'string' && list.length > 0) {
        title += ` (${list.length})`;
    }

    return (
        <span>{title}</span>
    );
}

export default TabTitle;
